import { GiftCertificateEntity } from "~/interfaces/entities/GiftCertificate"
import { createEntitySlice } from "../createEntitySlice"

export const { slice: giftCertificates, selectors: giftCertificatesSelectors } =
  createEntitySlice<GiftCertificateEntity>("giftCertificates")
